import React from 'react'
import PropTypes from 'prop-types'
import { Dollars } from '@local/do-secundo-dollars'
import cx from 'classnames'

import styles from './MenuItemPrice.module.css'

export const MenuItemPrice = ({
  price,
  usesFractionalQuantity = false,
  unitOfMeasure = '',
  shouldRenderSchema
}) => (
  <span
    data-testid='menu-item-price'
    className={cx(styles.price, 'type-default')}
    itemProp={shouldRenderSchema && 'offers'}
    itemScope={shouldRenderSchema}
    itemType={shouldRenderSchema && 'https://schema.org/Offer'}
  >
    <Dollars amount={price} />
    {usesFractionalQuantity && `/${unitOfMeasure.toLowerCase()}`}
  </span>
)

MenuItemPrice.propTypes = {
  price: PropTypes.number.isRequired,
  usesFractionalQuantity: PropTypes.bool,
  unitOfMeasure: PropTypes.string,
  shouldRenderSchema: PropTypes.bool
}
